import { cn } from "@/lib/utils";

/** A labelled component demo with a soft canvas. */
export function Showcase({ title, description, children, tone = "card", className }) {
  return (
    <div className="min-w-0">
      {(title || description) && (
        <div className="mb-3">
          {title && <h3 className="font-display text-lg font-extrabold">{title}</h3>}
          {description && <p className="text-sm font-medium text-muted-foreground">{description}</p>}
        </div>
      )}
      <div
        className={cn(
          "rounded-3xl border border-border p-6 shadow-soft",
          tone === "muted" ? "bg-muted/40" : "bg-card",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}

/** Small caption used to label a state (Hover / Pressed / Disabled…). */
export function StateLabel({ children }) {
  return <p className="mb-2 text-xs font-bold uppercase tracking-wider text-muted-foreground">{children}</p>;
}

/** A device frame for previewing navigation chrome. */
export function DeviceFrame({ type = "phone", label, children }) {
  const sizes = {
    phone: "max-w-[340px] rounded-[2.25rem] p-2.5",
    tablet: "max-w-[560px] rounded-[2rem] p-3",
    desktop: "max-w-full rounded-[1.75rem] p-3",
  };
  return (
    <div className="flex w-full min-w-0 flex-col items-center gap-2">
      <div className={cn("w-full border-[6px] border-foreground/10 bg-background shadow-soft-lg", sizes[type])}>
        <div className="overflow-hidden rounded-[1.4rem] border border-border bg-background">{children}</div>
      </div>
      {label && <span className="text-xs font-bold text-muted-foreground">{label}</span>}
    </div>
  );
}
